/** UUIDv7: time-ordered, so ids sort by creation and cursor pagination works on them (plan §3.1). Web Crypto, so the same
 *  code runs in Node and in the browser (the shared package is imported by both). */
export function uuidv7(now: number = Date.now()): string {
  const time = BigInt(now).toString(16).padStart(12, "0");
  const rand = new Uint8Array(10); globalThis.crypto.getRandomValues(rand);
  const a = (0x7000 | (((rand[0]! << 8) | rand[1]!) & 0x0fff)).toString(16);
  const b = (0x8000 | (((rand[2]! << 8) | rand[3]!) & 0x3fff)).toString(16);
  const c = Array.from(rand.subarray(4, 10), (x) => x.toString(16).padStart(2, "0")).join("");
  return `${time.slice(0, 8)}-${time.slice(8, 12)}-${a}-${b}-${c}`;
}

export const UUID_V7 = /^[0-9a-f]{8}-[0-9a-f]{4}-7[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/;
